import moment from 'moment';

import type { IFamilyAttendance, ITrainingTopic } from '../../../../utils/types';

export const allTopicsEligibilityThreshold = 0.25;

function isEligibleForAllTopics(attendance: IFamilyAttendance, sessionDuration: number): boolean {
  return attendance.duration / sessionDuration > allTopicsEligibilityThreshold;
}

export function checkAllTopicMapError(
  attendance: IFamilyAttendance,
  sessionTopics: ITrainingTopic[],
  sessionDuration: number,
): boolean {
  const isEligibleForAll = isEligibleForAllTopics(attendance, sessionDuration);
  const hasAllTopics = sessionTopics.length === attendance.topics.length;
  return !isEligibleForAll && hasAllTopics && sessionTopics.length > 1;
}

export function checkInvalidFamilyAttendance(
  sessionDuration: number,
  sessionStartTime: string,
  attendances: IFamilyAttendance[],
): boolean {
  const gpsnStartTime = moment(sessionStartTime);
  const gpsnEndTime = moment(sessionStartTime).add(sessionDuration, 'seconds');
  return (
    attendances?.some(
      (attendance) =>
        moment(attendance.date_start).isBefore(moment(gpsnStartTime)) ||
        moment(attendance.date_end).isAfter(moment(gpsnEndTime)),
    ) ?? false
  );
}
